<div
    class="miles-editable miles-card padded"
    *ngIf="!isEditing && carrier.Id > 0"
    (mouseenter)="isHovered = true"
    (mouseleave)="isHovered = false"
    (click)="edit()"
    [style.cursor]="canEdit ? 'pointer' : 'default'"
>
    <h4>
        Carrier Info
        <span class="pull-right" *ngIf="canEdit" [hidden]="!isHovered">
            <i class="fa fa-lg fa-edit"></i>
        </span>
    </h4>
    <mt-dynamic-view [config]="viewOnly"></mt-dynamic-view>
</div>
<div *ngIf="isEditing && canEdit" class="miles-form padded">
    <h4>Carrier</h4>
    <mt-dynamic-form [config]="formObject" (submitted)="formSubmitted($event)">
        <button type="button" Class="btn btn-flat btn-primary" (click)="markAsPaid()" [disabled]="!carrier?.Id" style="margin-right: 10px;">
            Paid
        </button>
        <button type="submit" mtDisableClickDuringHttpCalls Class="btn btn-flat btn-success">
            Save
        </button>
        <button type="button" Class="btn btn-flat btn-default" (click)="cancelClick()">Cancel</button>
    </mt-dynamic-form>
</div>